import { render, staticRenderFns } from "./TaxAnalysis.vue?vue&type=template&id=453f50c8&scoped=true&"
import script from "./TaxAnalysis.vue?vue&type=script&lang=js&"
export * from "./TaxAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TaxAnalysis.vue?vue&type=style&index=0&id=453f50c8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f50c8",
  null
  
)

export default component.exports